import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, BookOpenIcon } from 'lucide-react';
import { FlipbookModal } from './FlipbookModal';
const navLinks = ['About', 'Expertise', 'Experience', 'Impact', 'Contact'];
const resumePages = ['https://cdn.magicpatterns.com/uploads/fQs35j5VZ81uHZtVubjArZ/Resume.Maddox.png', 'https://cdn.magicpatterns.com/uploads/cLBriFMw6rgCx5Aj1uE7CP/Maddox._Resume.png'];
export function HeroSection() {
  const [resumeOpen, setResumeOpen] = useState(false);
  return <>
      <div className="w-full min-h-screen flex flex-col" style={{
      background: 'linear-gradient(135deg, #0a1628 0%, #0d1f4e 35%, #1a3a8f 70%, #1e4db7 100%)',
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-136">
        {/* Sticky Navbar */}
        <nav className="sticky top-0 z-50 w-full flex items-center justify-between px-8 md:px-16 py-4" style={{
        background: 'rgba(10, 22, 40, 0.85)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-137">
          <span className="text-white font-bold text-lg tracking-tight" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-138">
            Robert Maddox
          </span>
          <ul className="hidden md:flex items-center gap-8" data-id="element-139">
            {navLinks.map(link => <li key={link} data-id="element-140">
                <a href={`#${link.toLowerCase()}`} className="text-white/80 hover:text-white text-sm font-medium transition-colors duration-200 tracking-wide" data-id="element-141">
                  {link}
                </a>
              </li>)}
          </ul>
          <div className="md:hidden flex flex-col gap-1.5 cursor-pointer" data-id="element-142">
            <span className="block w-6 h-0.5 bg-white/80" data-id="element-143" />
            <span className="block w-6 h-0.5 bg-white/80" data-id="element-144" />
            <span className="block w-4 h-0.5 bg-white/80" data-id="element-145" />
          </div>
        </nav>

        {/* Hero Body */}
        <div className="flex-1 flex items-center" data-id="element-146">
          <div className="w-full max-w-7xl mx-auto px-8 md:px-16 py-16 md:py-20" data-id="element-147">
            <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-148">
              {/* Left: Photo */}
              <motion.div className="flex-shrink-0 w-full md:w-auto flex justify-center" initial={{
              opacity: 0,
              x: -60
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.7,
              ease: [0.25, 0.46, 0.45, 0.94]
            }} data-id="element-149">
                <div style={{
                borderRadius: '16px',
                padding: '4px',
                background: 'linear-gradient(145deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%)',
                boxShadow: '0 0 40px rgba(255,255,255,0.15), 0 20px 60px rgba(0,0,0,0.4)'
              }} data-id="element-150">
                  <img src="https://cdn.magicpatterns.com/uploads/dcZAsDsWAsdkgz2XjWYQF2/WhatsApp_Image_2026-03-02_at_21.53.55.jpg" alt="Robert Maddox — Operations Executive" className="block object-cover object-top" style={{
                  width: '340px',
                  height: '420px',
                  borderRadius: '13px',
                  objectPosition: 'center top'
                }} data-id="element-151" />
                </div>
              </motion.div>

              {/* Right: Text Content */}
              <div className="flex-1 flex flex-col gap-5 text-center md:text-left" data-id="element-152">
                <motion.p className="text-blue-300/90 text-xs md:text-sm font-semibold tracking-[0.2em] uppercase" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.5,
                delay: 0.3
              }} data-id="element-153">
                  Operations Executive &amp; Manufacturing Leader
                </motion.p>

                <motion.h1 className="text-white font-extrabold leading-[1.05] text-4xl md:text-5xl lg:text-6xl" style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: '-0.02em'
              }} initial={{
                opacity: 0,
                y: 25
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.45
              }} data-id="element-154">
                  Operations Leader Driving Large-Scale Manufacturing
                  Transformation
                </motion.h1>

                <motion.p className="text-white/75 text-base md:text-lg leading-relaxed max-w-2xl" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.6
              }} data-id="element-155">
                  20+ years leading aviation maintenance, manufacturing, and
                  program management — delivering 80% productivity gains, 65%
                  on-time delivery improvement, and $12.65M in managed projects
                  through Lean transformation, disciplined execution, and
                  zero-defect leadership.
                </motion.p>

                {/* CTA Buttons */}
                <motion.div className="flex flex-col sm:flex-row gap-3 mt-2 justify-center md:justify-start" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.75
              }} data-id="element-156">
                  <a href="#experience" className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-white text-gray-900 font-semibold text-sm transition-all duration-200 hover:bg-gray-100 active:scale-95" data-id="element-157">
                    View Experience
                  </a>

                  <a href="#contact" className="inline-flex items-center justify-center px-6 py-3 rounded-md font-semibold text-sm text-white transition-all duration-200 hover:bg-white/10 active:scale-95" style={{
                  border: '2px solid rgba(255,255,255,0.7)'
                }} data-id="element-158">
                    Contact Me
                  </a>

                  {/* View Resume — opens flipbook */}
                  <motion.button onClick={() => setResumeOpen(true)} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md font-semibold text-sm text-white relative overflow-hidden" whileHover={{
                  scale: 1.04
                }} whileTap={{
                  scale: 0.97
                }} style={{
                  background: 'linear-gradient(135deg, rgba(201,150,62,0.25), rgba(201,150,62,0.1))',
                  border: '1.5px solid rgba(201,150,62,0.7)',
                  cursor: 'pointer',
                  boxShadow: '0 0 20px rgba(201,150,62,0.2)'
                }} data-id="element-159">
                    {/* Shimmer */}
                    <motion.div className="absolute inset-0 pointer-events-none" animate={{
                    x: ['-100%', '200%']
                  }} transition={{
                    duration: 2.5,
                    repeat: Infinity,
                    repeatDelay: 1.5,
                    ease: 'easeInOut'
                  }} style={{
                    background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.15) 50%, transparent 60%)'
                  }} data-id="element-160" />
                    <BookOpenIcon className="w-4 h-4" data-id="element-161" />
                    View Resume
                  </motion.button>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Resume Flipbook Modal */}
      <FlipbookModal isOpen={resumeOpen} onClose={() => setResumeOpen(false)} title="Executive Resume — Robert Maddox" pages={resumePages} data-id="element-162" />
    </>;
}